import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import IconButton from "../../../../../components/IconButton";
import Spinner from "../../../../../components/Spinner";
import useAuthData from "../../../../../hook/useAppData";
import { IconLeftArrowVersion2 } from "../../../../../icons";
import { FormImmobilizedInventory } from "./components/FormImmobilizedInventory";

import "./index.scss";
import { getImmobilizedByid } from "./libs/reqs";
import { ImmobilizedProvider } from "./store";
import useImmolizedStore from "./store/useStore";

export function FormInventoryImmobilized(props: any) {
  const parametros = props.match.params?.id;
  return (
    <ImmobilizedProvider>
      <InventoryImmobilizedForm params={parametros} />
    </ImmobilizedProvider>
  );
}
function InventoryImmobilizedForm(props) {
  const { token } = useAuthData();
  const { defaultValues, createOrUpdate, needSpinner } = useImmolizedStore();
  const { setDefaultValues, setState, setCreateOrUpdate, setNeedSpinner, handleExitClick } = useImmolizedStore();

  const parametros = props.params;

  useEffect(() => {
    if (parametros) {
      setCreateOrUpdate("update");
      getImmobilizedByid(parametros, token, setDefaultValues, setState, setNeedSpinner);
    }
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 500);
  }, [createOrUpdate]);

  return (
    <>
      <Toaster />
      <div className="container immobilized-inventory-div">
        <div className="form-box-title title-form header-immobilized-form">
          <IconButton onClick={handleExitClick} className="title-arrow pointer" icon={IconLeftArrowVersion2} />
          <h1 className="row ">
            {createOrUpdate == "create" ? "Adicionar Novo" : "Atualizar"} Item {defaultValues?.name && "- " + defaultValues?.name}{" "}
          </h1>
        </div>

        <Spinner status={needSpinner}>
          <FormImmobilizedInventory params={parametros} />
        </Spinner>
      </div>
    </>
  );
}
